import {
  ConfigurationApi,
  configurationApiRef,
} from '@agilelab/plugin-wb-configuration-common';
import { useApi } from '@mainstage/core-plugin-api';
import { useQuery as useReactQuery } from '@tanstack/react-query';

const STALE_TIME = 1000 * 60 * 5;
export const DEVELOPER_TOOLS_ENABLED_QUERY_KEY = [
  'platformDeveloperToolsEnabled',
];

const queryFn = (wbConfigApi: ConfigurationApi) => async () => {
  const value = await wbConfigApi.get<boolean>({
    namespace: 'platform',
    key: 'fe.developerTools.enabled',
  });
  return value ?? false;
};

export const useDeveloperToolsEnabled = (noCache?: boolean) => {
  const wbConfigApi = useApi(configurationApiRef);
  const { data, isLoading, error } = useReactQuery(
    DEVELOPER_TOOLS_ENABLED_QUERY_KEY,
    queryFn(wbConfigApi),
    {
      staleTime: noCache ? 0 : STALE_TIME,
    },
  );
  return { enabled: data ?? false, isLoading, error };
};
